import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { ResetPasswordForm } from './use-reset-password.form';

export const useResetPasswordFormContext = ():
  | UseFormReturn<ResetPasswordForm>
  | never => {
  const form = useFormContext<ResetPasswordForm>();

  if (form === null)
    throw AppError.hookScopeError('useResetPasswordFormContext error.');

  return form;
};
